<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Copy Appraisal Masters</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
       <v-row justify="center" dense>
               <v-col cols="12" sm="3" md="3">
                  <p><v-icon color="error">*</v-icon><b>From Academic Year</b></p>
                  <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
            </v-col>
            <v-col cols="12" sm="3" md="3">
                  <p><v-icon color="error">*</v-icon><b>To Academic Year</b></p>
                  <v-autocomplete color="#0F2027" dense rounded required v-model="to_ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
            </v-col>
            </v-row>
            <v-row justify="center" dense>
                <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                <v-radio
                  label="Appraisal Level"
                  value="level"
                  color="#0f2027"
                ></v-radio>
                <v-radio
                  label="Appraisal Parameter"
                  value="parameter"
                  color="#0f2027"
                ></v-radio>
                 <v-radio
                  label="Appraisal Sub-Parameter"
                  value="sub-parameter"
                  color="#0f2027"
                ></v-radio>
                 <v-radio
                  label="Appraisal Evaluation-Parameter"
                  value="eval-parameter"
                  color="#0f2027"
                ></v-radio>
                  <v-radio
                  label="Appraisal Parameter Linking"
                  value="linking"
                  color="#0f2027"
                ></v-radio>
             </v-radio-group>
            </v-row>

             <v-row justify="center" dense>
                <v-btn rounded class="primary" style="color:orange" @click="copyAppraisalMasters()" :loading="loader" v-if="to_ay && this.radios">Copy</v-btn>
             </v-row>
       </v-card>

     <!-- <v-card class="box" v-if="query_list.length > 0">
     <v-data-table  :headers="headers" :items="query_list" >
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Queries</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
     </v-data-table>
 </v-card> -->
        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      ay_list:[],ay:"",to_ay:"",radios:null
     
  }),
   methods: {
    copyAppraisalMasters() {
            const data = {
                ay:this.ay,
                to_ay:this.to_ay,
                radios:this.radios
            }
            this.learner_info=[]
            axios
                .post("/SelfAppriasalMaster/copyAppraisalMaster", data)
                .then((res) => {
                   if (res.data.flag == "Yes") {
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
    onLoad() {
        axios
            .post("SelfAppriasalMaster/appraisalCredit")
            .then((res) => {
                if (res.data.flag == "YES") {
                    (this.ay_list = res.data.ay_list),
                     (this.ay = res.data.current_ay);
                    this.overlay = false;
                } else {
                    this.showSnackbar("#b71c1c", res.data.status_reason);
                }
            })
            .catch((error) => {
                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                this.overlay = false;
            })
            .finally(() => {
                this.overlay = false;
            });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>